class ServiceWorkerUtils {

    static register(): Promise<ServiceWorkerRegistration> {
        if ("serviceWorker" in navigator) {
            return navigator.serviceWorker.register("js/service-worker.js");
        } else {
            Promise.reject("Service Worker not Available in Navigator.");
        }
    }

    static unregister(): void {
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.ready.then(registration => {
                registration.unregister();
            });
        }
    }

}

export default ServiceWorkerUtils